module.exports = __webpack_public_path__ + "static/img/3.99f125c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/7/1/zh/3.png
// module id = riq7
// module chunks = 0